<template>
  <div class="signUp">
    <Header></Header>
    <Nav type="6"></Nav>
    <Toptitle title="我要报名"></Toptitle>
    <div class="signUp_center">
      <el-input placeholder="作品标题" class="signUp_input"/>
      <el-input type="textarea" :rows="4" placeholder="作品详情"></el-input>
      <div class="writeBtnDiv"><span class="releaseBtn writebtn">发布</span><span class="previewBtn writebtn">预览</span></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    methods: {

    },
  }
</script>

<style>
</style>

